// api/UserManager.js
import { createEntityManager, resolveVarsFromContext } from "./EntityManager";

import { loadOntology } from "./OntologyUtils";

/**
 * Get a Profile entity for the given userId using EntityManager.
 *
 * @param {object} params
 * @param {string} params.userId         Cognito Identity ID (maps to {COGNITO_ID})
 * @param {object} params.awsCreds       AWS credentials/context for data access
 * @param {string} [params.ontologyPath] Optional override to user.yaml path
 *
 * @returns {Promise<object>} The user object from mgr.get({ vars, awsCreds })
 */
export async function getProfile(userId, awsCreds, ontology = "profile") {
  if (!userId) throw new Error("getProfile: 'userId' is required");
  if (!awsCreds) throw new Error("getProfile: 'awsCreds' is required");

  const ontologyObj = await loadOntology(ontology);
  // Create the manager using the user ontology
  const mgr = createEntityManager(ontologyObj, {
    bucketName: process.env.REACT_APP_AZRIUS_APP_BUCKET,
  });

  // Build template vars from context (maps userId -> {COGNITO_ID} etc.)
  const vars = resolveVarsFromContext(mgr.meta, { userId });

  // Retrieve and return the user entity
  const entity = await mgr.get({ vars, awsCreds });

  return entity;
}

export default { getUser: getProfile };
